module.exports = __webpack_public_path__ + "static/media/eap-support@3x.f5e033c9.png";